import type { IconProps } from '../types/IconProps.ts';
export const Home: IconProps = {
    name: 'Home',
    children: [
        `<path d="M3 9.47a1 1 0 0 1 .36-.77l8-6.67a1 1 0 0 1 1.28 0l8 6.67a1 1 0 0 1 .36.77V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />`,
        `<path d="M9 21v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7" />`,
    ]
};